<template>
    <div class="footer">
        <p>版权所有© 广南民族文化旅游产业有限公司 滇ICP备202100329号</p>
        <p>技术支持：浙江深大智能科技有限公司</p>
    </div>
</template>
<script>
export default {
    
    data() {
    return {
     
    };
  },
    methods: {
      
  }
}
</script>
<style scoped lang="scss">

.footer{
  width: 100%;
  background: #f8f8f8;
  height: 52px;
  padding-top: 5px;
  p{
    text-align: center;
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }

}

</style>


// WEBPACK FOOTER //
// src/pages/bamei/components/footer.vue